import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hire-slider-education-view',
  imports: [TitleCasePipe],
  templateUrl: './hire-slider-education-view.component.html',
  styleUrl: './hire-slider-education-view.component.scss',
})
export class HireSliderEducationViewComponent {
  @Input() education: any;
  @Input() highlighteducation: any;

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {
  }


  formatDate(dateString: string): string {
    if (dateString == null || dateString == 'null') {
      return '';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If the date is not valid, or it's just a year (e.g., "2014")
      // then we return it as it is.
      return dateString;
    } else if (dateString && dateString.length === 4) {
      // If the date string contains only the year (e.g., "2014"),
      // we format it as "YYYY" (e.g., "2014")
      return this.datePipe.transform(date, 'yyyy');
    } else {
      // If it's a full date, we format it as "MMMM yyyy" (e.g., "January 2014")
      return this.datePipe.transform(date, 'MMMM yyyy');
    }

  }
}
